var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("thead", [
    _c(
      "tr",
      _vm._l(_vm.headers, function (header) {
        return _c(
          "th",
          {
            key: header.value,
            class: header.class,
            attrs: { Width: header.width },
            on: {
              click: function ($event) {
                header.sortable ? _vm.$emit("sort", header.value) : null
              },
            },
          },
          [
            _c(
              "v-row",
              {
                staticClass: "ma-0",
                class: header.class,
                attrs: { align: "center", justify: header.align },
              },
              [
                _c(
                  "div",
                  { staticClass: "d-flex align-center ma-0" },
                  [
                    header.value === "data-table-select"
                      ? _c("v-checkbox", {
                          staticClass: "custom-checkbox pa-0",
                          attrs: {
                            "input-value":
                              header.all ||
                              !!_vm.$store.state.documents
                                .sendTypeToggleDropdown,
                            dense: "",
                            color: "green-500",
                            "hide-details": "",
                          },
                          on: {
                            change: function ($event) {
                              return _vm.$emit("isSelected", $event)
                            },
                            click: function ($event) {
                              return _vm.$emit("toggleAll")
                            },
                          },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
                _c(
                  "span",
                  [
                    _vm._v(_vm._s(header.text) + " "),
                    header.sortable &&
                    ![
                      "PosRetrieveUpdate",
                      "BranchRetrieveUpdate",
                      "DocumentsRetrieve",
                      "CustomerRetrieveUpdate",
                      "PurchaseRetrieve",
                      "SupplierRetrieveUpdate",
                    ].includes(_vm.$route.name)
                      ? [
                          _c(
                            "v-icon",
                            { attrs: { color: "grey-700", "x-small": "" } },
                            [_vm._v("mdi-swap-vertical-bold")]
                          ),
                        ]
                      : _vm._e(),
                  ],
                  2
                ),
              ]
            ),
          ],
          1
        )
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }